import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0a83bc06&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/selectTheNft.scss?vue&type=style&index=0&id=0a83bc06&lang=scss&scoped=true&"
import style1 from "./index.vue?vue&type=style&index=1&lang=scss&"
import style2 from "./index.vue?vue&type=style&index=2&id=0a83bc06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a83bc06",
  null
  
)

export default component.exports